import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import {
  ADD_API_CONFIGURATIONS,
  ADD_CHILDREN_NODE_ITEM_FROM_FORM_MODEL,
  ADD_DELETED_NEW_ELEMENT,
  ADD_ELEMENTS_TO_FORM_MODEL,
  ADD_NEW_ELEMENT_ID_LIST,
  CHANGE_DATASOURCE,
  CHANGE_IS_DOCK_TO_BOTTOM,
  CLEAR_CHANGED_DATASOURCES,
  CLEAR_MOVED_FIELDS,
  COPY_TEMP_STATE,
  DELETE_CHILDREN_NODE_ITEM_FROM_FORM_MODEL,
  DELETE_DATASOURCES,
  MOVE_CONTROL_BY_BUTTON,
  MOVE_CONTROL_BY_DND_TO_ANOTHER_CONTAINER,
  MOVE_CONTROL_BY_DND_TO_EMPTY_CONTAINER,
  MOVE_CONTROL_BY_DND_WITHIN_CONTAINER,
  ORIGINAL_DATA_SOURCES,
  ORIGINAL_FORM_MODEL,
  REDO_USER_ACTION,
  REMOVE_FROM_DELETED_ELEMENT_ARRAY,
  REPLACE_ADDED_ELEMENTS_TO_FORM_MODEL,
  REPLACE_DATASOURCE,
  SESSION_FORM_MODEL,
  SET_CONFIRM_MODAL_OPEN,
  SET_HEIGHT_OF_TABLE,
  SET_SEARCH_RESULT,
  SET_SELECTED_CONTROL,
  SET_WIDTH_OF_TABLE,
  TOGGLE_EDIT_MODE,
  UNDO_USER_ACTION,
  UPDATE_ADDED_FIELDS_FORM_MODEL_LIST,
  UPDATE_CONTROL,
  UPDATE_FORM_INFO,
  UPDATE_FORM_MODEL_ADD_ELEMENT,
  UPDATE_FORM_MODEL_BY_ID_AND_PROP,
  UPDATE_FORM_MODEL_DELETE_ELEMENTS,
  UPDATE_MOVED_FIELDS_AFTER_MOVE,
  UPDATE_NEW_ADDED_ELEMENT_LIST_AFTER_DELETION,
  UPDATE_USER_ACTION_ARRAY,
} from './../actions/editor.actions';
import { insertAll, set } from '../../utils/ramdaUtils';
import {
  REMOVE_SELECTED_IDS_PER_PAGE,
  SELECT_ALL_IDS_PER_PAGE,
  SET_BULK_EDIT_DATA,
  SET_SINGLE_SELECTED_ID,
} from '../actions/bulk-edit-actions';
import {
  REPLACE_FROM_CHANGED_DATASOURCE_LIST,
  UPDATE_DATASOURCE_LIST,
} from '../actions/data-source.actions';
import { UPLOAD_ATTACHMENTS_SUCCESS } from '../actions/file-upload.actions';
import {
  CLEAR_FORM_DESIGNER,
  LOAD_DATA,
  LOAD_FORM,
  SAVE_SIMILAR_RECORDS_DATA,
  SET_FORM_IMPORT_MODE,
  SET_SIMILAR_RECORDS_DATA_FETCHED,
  SET_SUPPORT_DATA,
  UPDATE_DELTA_CHANGES,
  UPDATE_FORM_MODEL,
  UPDATE_LAYOUT_CHANGES,
  UPDATE_NEW_ELEMENTS_NODE,
} from '../actions/form-manager.actions';
import {
  ADD_NEW_ROW,
  BULK_ADDING_NEW_ROWS,
  BULK_UPDATE_FORM_DATA,
  CLEAR_TABLE,
  DELETE_FORM_DATA_ROW,
  IS_MODULE_LICENSED,
  SET_ACTIVE_CONTAINERS,
  SET_DATE_ADD_BUSINESS_DAYS,
  SET_FORM_CHANGES_TABLE_ROWS,
  SET_IS_FORM_CHANGES_MODE,
  SET_IS_FORM_CHANGES_TABLE_LOADING,
  SET_NUMBERING_SCHEME,
  SET_SHOULD_EXECUTE_SET_DEFAULT_ACTIONS,
  SET_SHOULD_SKIP_FORM_RULES_EVALUATION,
  SET_USER_MADE_INTERACTION,
  UPDATE_DATA_SUCCESS,
  UPDATE_ENTITY_DATA,
  UPDATE_ENTITY_ROWS,
  UPDATE_ORIGINAL_DATA,
  UPDATE_SELECTED_SUB_GRIDS,
} from '../actions/runtime.actions';
import { FORM_KEYS } from '../constants/form-manager.constants';
import { getDataPath } from '../utils/form-manager.utils';
import {
  generateRowId,
  getEntityDataWithUpdatedValues,
  getFormDesignerWithUpdatedEntityData,
} from '../utils/runtime.utils';

function formManagerReducer(state = {}, action) {
  const { formKey = FORM_KEYS.EDITOR } = action;
  const { entityDefinition } = state[formKey] || {};

  if (action.type !== LOAD_FORM && action.type !== LOAD_DATA && !state[formKey]) {
    return state;
  }

  switch (action.type) {
    case SET_WIDTH_OF_TABLE: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          panel: { ...state[formKey].panel, ...action.payload },
        },
      };
    }

    case SET_HEIGHT_OF_TABLE: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          panel: { ...state[formKey].panel, ...action.payload },
        },
      };
    }

    case CHANGE_IS_DOCK_TO_BOTTOM: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          panel: { ...state[formKey].panel, ...action.payload },
        },
      };
    }

    case LOAD_FORM: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          ...action.payload,
        },
      };
    }

    case LOAD_DATA: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          ...action.payload,
        },
      };
    }

    case UPDATE_FORM_MODEL:
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: action.payload.newFormModel,
        },
      };

    case UPDATE_FORM_INFO:
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formInfo: action.payload.formInfo,
        },
      };

    case UPDATE_DELTA_CHANGES: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          deltaChanges: action.payload.deltaChanges,
        },
      };
    }

    case UPDATE_LAYOUT_CHANGES: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          layoutChanges: action.payload.Layout,
        },
      };
    }

    case UPDATE_ENTITY_DATA:
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          data: {
            ...state[formKey].data,
            entityDataStore: {
              entityData: action.payload.newEntityData,
            },
          },
        },
      };

    case UPDATE_NEW_ELEMENTS_NODE: {
      const { AddedFields = [], DeletedFields = [], MovedFields = [] } = action.payload;
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          AddedFields,
          DeletedFields,
          MovedFields,
          AddedFieldsFormModel: [],
          DeletedFieldsFormModel: [],
          MovedFieldsFormModel: [],
        },
      };
    }

    case UPDATE_FORM_MODEL_ADD_ELEMENT: {
      const { element = {} } = action.payload;
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: _.assign(state[formKey].formModel, element),
        },
      };
    }

    case UPDATE_FORM_MODEL_DELETE_ELEMENTS:
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: _.omit(state[formKey].formModel, action.payload.controlsIds ?? []),
        },
      };

    case UPDATE_FORM_MODEL_BY_ID_AND_PROP: {
      const { id, prop, value } = action.payload;
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: {
            ...state[formKey].formModel,
            [id]: {
              ...state[formKey].formModel[id],
              [prop]: value,
            },
          },
        },
      };
    }

    case UPDATE_CONTROL: {
      const { id, controlChanges } = action.payload;
      const controlDetails = state[formKey].formModel[id];
      const newControlBody = {
        ...controlDetails,
        ...controlChanges,
      };

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: {
            ...state[formKey].formModel,
            [id]: newControlBody,
          },
        },
      };
    }

    case ADD_CHILDREN_NODE_ITEM_FROM_FORM_MODEL: {
      const { controlParentId, childNodeId, previousControlId } = action.payload;

      const currentChildrenNodes = [...state[formKey].formModel[controlParentId].childrenNodes];
      if (previousControlId || previousControlId === '') {
        const index = currentChildrenNodes.findIndex((el) => el === previousControlId);
        currentChildrenNodes.splice(1 + index, 0, childNodeId);
      }

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: {
            ...state[formKey].formModel,
            [controlParentId]: {
              ...state[formKey].formModel[controlParentId],
              childrenNodes: [...currentChildrenNodes],
            },
          },
        },
      };
    }

    case DELETE_CHILDREN_NODE_ITEM_FROM_FORM_MODEL: {
      const { controlParentId, childNodeId } = action.payload;

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: {
            ...state[formKey].formModel,
            [controlParentId]: {
              ...state[formKey].formModel[controlParentId],
              childrenNodes: [
                ...state[formKey].formModel[controlParentId].childrenNodes.filter(
                  (item) => item !== childNodeId
                ),
              ],
            },
          },
        },
      };
    }

    case ADD_NEW_ELEMENT_ID_LIST: {
      const { element, optionsSelect, previousControlId } = action.payload;
      const {
        controlId = '',
        parent = '',
        controlType = '',
        defaultLabel = '',
        saved = false,
      } = element[Object.keys(element)];

      const elements = [...state[formKey].AddedFieldsFormModel].map((ele) => {
        if (ele.previousControlId === previousControlId && previousControlId !== '') {
          ele.previousControlId = controlId;
          return ele;
        }
        return ele;
      });

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          AddedFieldsFormModel: [
            ...elements,
            {
              controlId,
              parent,
              controlType,
              defaultLabel,
              previousControlId,
              optionsSelect,
              saved,
            },
          ],
        },
      };
    }

    case UPDATE_NEW_ADDED_ELEMENT_LIST_AFTER_DELETION: {
      const { formModel, AddedFieldsFormModel } = state[formKey];

      const elements = AddedFieldsFormModel.filter((element) => formModel[element.controlId]);

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          AddedFieldsFormModel: [...elements],
        },
      };
    }

    case UPDATE_ADDED_FIELDS_FORM_MODEL_LIST: {
      const savedElements = [
        ...state[formKey].AddedFieldsFormModel.map((item) => {
          item.saved = true;
          return item;
        }),
      ];

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          AddedFieldsFormModel: [...savedElements],
          DeletedFieldsFormModel: [],
        },
      };
    }

    case ADD_DELETED_NEW_ELEMENT: {
      const { element } = action.payload;
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          DeletedFieldsFormModel: [...state[formKey].DeletedFieldsFormModel, element],
        },
      };
    }

    case UPDATE_ORIGINAL_DATA:
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          originalData: action.payload.formData,
        },
      };

    case UPDATE_DATA_SUCCESS:
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          data: action.payload.formData,
        },
      };

    case BULK_UPDATE_FORM_DATA: {
      const { changesArray } = action.payload;

      const updatedEntityData = getEntityDataWithUpdatedValues(state, formKey, changesArray);
      const newState = getFormDesignerWithUpdatedEntityData(state, formKey, updatedEntityData);

      return newState;
    }

    case UPLOAD_ATTACHMENTS_SUCCESS: {
      const { entityName, result, index = [0] } = action.payload;

      const path = getDataPath(entityName, index, entityDefinition).slice(0, -1);
      const allRows = _.get(state[formKey].data?.entityDataStore?.entityData, path, []);
      const rows = [...allRows, result];
      const entityData = set(state[formKey].data.entityDataStore.entityData, path, rows);

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          data: {
            ...state[formKey].data,
            entityDataStore: {
              ...state[formKey].data.entityDataStore,
              entityData,
            },
          },
        },
      };
    }

    case DELETE_FORM_DATA_ROW: {
      const { entityName, rowIndex, index = [0] } = action.payload;

      const path = getDataPath(entityName, index, entityDefinition).slice(0, -1);
      const allRows = _.get(state[formKey].data?.entityDataStore?.entityData, path, []);
      const rows = allRows.filter((_, i) => i !== rowIndex);
      const entityData = set(state[formKey].data.entityDataStore.entityData, path, rows);

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          data: {
            ...state[formKey].data,
            entityDataStore: {
              ...state[formKey].data.entityDataStore,
              entityData,
            },
          },
          shouldExecuteSetDefaultActions: true,
        },
      };
    }

    case TOGGLE_EDIT_MODE: {
      const { active } = action.payload;
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          tempFormModel: active ? _.cloneDeep(state[formKey]?.formModel) : null,
          active,
        },
      };
    }

    case ORIGINAL_FORM_MODEL: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          originalFormModel: _.cloneDeep(state[formKey]?.formModel),
        },
      };
    }

    case ORIGINAL_DATA_SOURCES: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          originalDataSources: _.cloneDeep(state[formKey]?.dataSources),
        },
      };
    }

    case SESSION_FORM_MODEL: {
      return {
        [formKey]: {
          ...state[formKey],
          sessionFormModel: _.cloneDeep(state[formKey]?.formModel),
        },
      };
    }

    case COPY_TEMP_STATE: {
      const { clear } = action.payload;
      return {
        [formKey]: {
          ...state[formKey],
          tempFormModel: clear ? null : _.cloneDeep(state[formKey]?.formModel),
        },
      };
    }

    case SET_SELECTED_CONTROL: {
      const { controlId, showControlWrapper } = action.payload;
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          selectedControl: { selectedControlId: controlId, showControlWrapper },
        },
      };
    }

    case ADD_NEW_ROW: {
      const { entityName, initialRowData = {}, index = [0] } = action.payload;
      initialRowData.IsNewObject = true;

      if (!initialRowData._newRowId) {
        initialRowData._newRowId = uuidv4();
      }

      const path = getDataPath(entityName, index, entityDefinition).slice(0, -1);
      const allRows = _.get(state[formKey].data?.entityDataStore?.entityData, path, []);
      initialRowData._tempAttachmentId = generateRowId(allRows, '_tempAttachmentId');
      const rows = [initialRowData, ...allRows];
      const entityData = set(state[formKey].data.entityDataStore.entityData, path, rows);

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          data: {
            ...state[formKey].data,
            entityDataStore: {
              ...state[formKey].data.entityDataStore,
              entityData,
            },
          },
          shouldExecuteSetDefaultActions: true,
        },
      };
    }

    case CLEAR_TABLE: {
      const { entityName, clearedRows, index = [0] } = action.payload;

      const path = getDataPath(entityName, index, entityDefinition).slice(0, -1);
      const entityData = set(state[formKey].data.entityDataStore.entityData, path, clearedRows);

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          data: {
            ...state[formKey].data,
            entityDataStore: {
              ...state[formKey].data.entityDataStore,
              entityData,
            },
          },
          shouldExecuteSetDefaultActions: true,
        },
      };
    }

    case BULK_ADDING_NEW_ROWS: {
      const { entityName, index = [0], newRows, insertMode = false } = action.payload;

      const path = getDataPath(entityName, index, entityDefinition).slice(0, -1);
      const allRows = _.get(state[formKey].data?.entityDataStore?.entityData, path, []);
      const mappedRows = newRows.map((row) => {
        return {
          ...row,
          IsNewObject: true,
          _newRowId: uuidv4(),
        };
      });
      const rows = insertAll(insertMode ? _.last(index) + 1 : 0, mappedRows, allRows);
      const entityData = set(state[formKey].data.entityDataStore.entityData, path, rows);

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          data: {
            ...state[formKey].data,
            entityDataStore: {
              ...state[formKey].data.entityDataStore,
              entityData,
            },
          },
        },
      };
    }

    case CLEAR_FORM_DESIGNER: {
      delete state[formKey];
      return { ...state };
    }

    case CHANGE_DATASOURCE: {
      const { dataSource } = action.payload;
      const { changedDatasources } = state[formKey];
      const existingDatasourceIndex =
        changedDatasources &&
        changedDatasources.findIndex((el) => el.dataSourceKey === dataSource?.dataSourceKey);

      if (existingDatasourceIndex >= 0) {
        changedDatasources[existingDatasourceIndex] = dataSource;
      }

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          changedDatasources:
            existingDatasourceIndex >= 0
              ? [...changedDatasources]
              : [...(changedDatasources || []), ...[dataSource]],
        },
      };
    }

    case DELETE_DATASOURCES: {
      const { dataSourcesKeys } = action.payload;
      const { dataSources } = state[formKey];
      let newDataSource = Object.assign({}, dataSources);
      if (dataSourcesKeys?.length > 0) {
        newDataSource = Object.keys(newDataSource)
          .filter((key) => !dataSourcesKeys.includes(key))
          .reduce((obj, key) => {
            obj[key] = newDataSource[key];
            return obj;
          }, {});
      }

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          dataSources: newDataSource,
        },
      };
    }

    case UPDATE_DATASOURCE_LIST: {
      const { datasource } = action.payload;
      const dataSourceKey = datasource?.dataSourceKey;
      const datasources = {
        ...state[formKey].dataSources,
        [dataSourceKey]: {
          ...datasource?.dataSourceProperties,
          dataSourceFrom: 'form',
          isNew: datasource.changeType === 'ADDED',
        },
      };
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          dataSources: datasources,
        },
      };
    }

    case MOVE_CONTROL_BY_DND_WITHIN_CONTAINER: {
      const { dragId, dropId, parentComponent } = action.payload;

      const newChildrenNodes = parentComponent.childrenNodes.filter((id) => id !== dragId);
      const dropIdIndex = newChildrenNodes.indexOf(dropId);
      newChildrenNodes.splice(dropIdIndex + 1, 0, dragId);

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: {
            ...state[formKey].formModel,
            [parentComponent.controlId]: {
              ...state[formKey].formModel[parentComponent.controlId],
              childrenNodes: newChildrenNodes,
            },
          },
        },
      };
    }

    case MOVE_CONTROL_BY_DND_TO_ANOTHER_CONTAINER: {
      const { dragId, dropId, dragParentComponent, dropParentComponent } = action.payload;

      const newDragParentComponentChildrenNodes = dragParentComponent.childrenNodes.filter(
        (id) => id !== dragId
      );
      const dropIdIndex = dropParentComponent.childrenNodes.indexOf(dropId);

      const newDropParentComponentChildrenNodes = [...dropParentComponent.childrenNodes];
      newDropParentComponentChildrenNodes.splice(dropIdIndex + 1, 0, dragId);

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: {
            ...state[formKey].formModel,
            [dragParentComponent.controlId]: {
              ...state[formKey].formModel[dragParentComponent.controlId],
              childrenNodes: newDragParentComponentChildrenNodes,
            },
            [dropParentComponent.controlId]: {
              ...state[formKey].formModel[dropParentComponent.controlId],
              childrenNodes: newDropParentComponentChildrenNodes,
            },
            [dragId]: {
              ...state[formKey].formModel[dragId],
              parent: dropParentComponent.controlId,
            },
          },
        },
      };
    }

    case MOVE_CONTROL_BY_DND_TO_EMPTY_CONTAINER: {
      const { dragId, dragParentComponent, dropComponent } = action.payload;

      const newDragParentComponentChildrenNodes = dragParentComponent.childrenNodes.filter(
        (id) => id !== dragId
      );

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: {
            ...state[formKey].formModel,
            [dragParentComponent.controlId]: {
              ...state[formKey].formModel[dragParentComponent.controlId],
              childrenNodes: newDragParentComponentChildrenNodes,
            },
            [dropComponent.controlId]: {
              ...state[formKey].formModel[dropComponent.controlId],
              childrenNodes: [dragId],
            },
            [dragId]: {
              ...state[formKey].formModel[dragId],
              parent: dropComponent.controlId,
            },
          },
        },
      };
    }

    case MOVE_CONTROL_BY_BUTTON: {
      const { parentControlId, childrenNodes } = action.payload;

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: {
            ...state[formKey].formModel,
            [parentControlId]: {
              ...state[formKey].formModel[parentControlId],
              childrenNodes,
            },
          },
        },
      };
    }

    case UPDATE_MOVED_FIELDS_AFTER_MOVE: {
      const { parentControlId, controlId } = action.payload;

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          MovedFieldsFormModel: [
            ...state[formKey].MovedFieldsFormModel,
            { parentControlId, controlId },
          ],
        },
      };
    }

    case CLEAR_MOVED_FIELDS: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          MovedFieldsFormModel: [],
        },
      };
    }
    case CLEAR_CHANGED_DATASOURCES: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          changedDatasources: [],
        },
      };
    }

    case SET_USER_MADE_INTERACTION:
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          userMadeInteraction: action.payload.flag,
        },
      };

    case SET_ACTIVE_CONTAINERS: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          activeContainers: action.payload.activeContainers,
        },
      };
    }

    case SET_CONFIRM_MODAL_OPEN: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          confirmModalOpen: action.payload.confirmModalOpen,
        },
      };
    }

    case UPDATE_SELECTED_SUB_GRIDS: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          selectedSubGrids: action.payload.newSelectedSubGrids,
        },
      };
    }

    case SET_BULK_EDIT_DATA: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          bulkEditData: { ...state[formKey].bulkEditData, ...action.payload.newData },
        },
      };
    }

    case SET_SINGLE_SELECTED_ID: {
      const { selectedId } = action.payload;
      const selectedIds = state[formKey]?.bulkEditData?.selectedIds || [];

      const newSelectedIds = selectedIds.includes(selectedId)
        ? selectedIds.filter((id) => id !== selectedId)
        : [...selectedIds, selectedId];

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          bulkEditData: { ...state[formKey].bulkEditData, selectedIds: newSelectedIds },
        },
      };
    }

    case REMOVE_SELECTED_IDS_PER_PAGE: {
      const { allRowsPerPage } = action.payload;
      const allRowsIds = allRowsPerPage.map((row) => row[row.PrimaryKeyColumn]);
      const filteredSelectedIds = state[formKey].bulkEditData.selectedIds.filter(
        (id) => !allRowsIds.includes(id)
      );

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          bulkEditData: { ...state[formKey].bulkEditData, selectedIds: filteredSelectedIds },
        },
      };
    }

    case SELECT_ALL_IDS_PER_PAGE: {
      const { allRowsPerPage } = action.payload;
      const allRowsIds = allRowsPerPage.map((row) => row[row.PrimaryKeyColumn]);
      const prevSelectedIds = state[formKey].bulkEditData.selectedIds || [];

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          bulkEditData: {
            ...state[formKey].bulkEditData,
            selectedIds: [...prevSelectedIds, ...allRowsIds],
          },
        },
      };
    }

    case ADD_API_CONFIGURATIONS: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          apiConfigurations: action.payload.apiConfigurations,
        },
      };
    }

    case UPDATE_ENTITY_ROWS: {
      const { newRows, entityName, index } = action.payload;

      const path = getDataPath(entityName, index, entityDefinition).slice(0, -1);
      const entityData = set(state[formKey].data.entityDataStore.entityData, path, newRows);

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          data: {
            ...state[formKey].data,
            entityDataStore: {
              ...state[formKey].data.entityDataStore,
              entityData,
            },
          },
        },
      };
    }

    case SET_NUMBERING_SCHEME: {
      const { numberingScheme } = action.payload;

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          numberingScheme,
        },
      };
    }

    case IS_MODULE_LICENSED: {
      const { moduleLicensed } = action.payload;

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          moduleLicensed,
        },
      };
    }

    case SET_DATE_ADD_BUSINESS_DAYS: {
      const { identifier, businessDaysDate } = action.payload;

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          businessDaysDate: {
            ...state[formKey].businessDaysDate,
            [identifier]: businessDaysDate,
          },
        },
      };
    }

    case SET_SHOULD_EXECUTE_SET_DEFAULT_ACTIONS: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          shouldExecuteSetDefaultActions: action.payload.flag,
        },
      };
    }

    case SET_SHOULD_SKIP_FORM_RULES_EVALUATION: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          shouldSkipFormRulesEvaluation: action.payload.flag,
        },
      };
    }

    case SET_SUPPORT_DATA: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          ...action.payload,
        },
      };
    }

    case UPDATE_USER_ACTION_ARRAY: {
      const { actionType, userChanges } = action.payload;

      let userActions = state[formKey]?.userActions?.actions ?? [];
      const actionPointer = state[formKey]?.userActions?.actionPointer ?? 0;

      if (actionPointer !== 0) {
        userActions = userActions.slice(actionPointer);
      }

      if (userActions.length === 10) {
        userActions.pop();
      }

      userActions.unshift({ actionType, userChanges });

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          userActions: {
            actions: [...userActions],
            actionPointer: 0,
          },
        },
      };
    }

    case UNDO_USER_ACTION: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          userActions: {
            ...state[formKey].userActions,
            actionPointer: state[formKey].userActions.actionPointer + 1,
          },
        },
      };
    }
    case REDO_USER_ACTION: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          userActions: {
            ...state[formKey].userActions,
            actionPointer: state[formKey].userActions.actionPointer - 1,
          },
        },
      };
    }

    case REPLACE_FROM_CHANGED_DATASOURCE_LIST: {
      const { dataSourcePrevState, dataSourceKey } = action.payload;
      const { changedDatasources } = state[formKey];
      const existingDatasourceIndex =
        changedDatasources &&
        changedDatasources.findIndex((el) => el.dataSourceKey === dataSourceKey);

      if (existingDatasourceIndex >= 0 && dataSourcePrevState) {
        changedDatasources[existingDatasourceIndex] = dataSourcePrevState;
      } else {
        changedDatasources.splice(existingDatasourceIndex, 1);
      }

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          changedDatasources: [...(changedDatasources || [])],
        },
      };
    }

    case REPLACE_DATASOURCE: {
      const { datasourceKey, datasourceProperties } = action.payload;

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          dataSources: {
            ...state[formKey].dataSources,
            [datasourceKey]: { ...datasourceProperties },
          },
        },
      };
    }

    case REMOVE_FROM_DELETED_ELEMENT_ARRAY: {
      const { controlId } = action.payload;
      const filteredArray =
        state[formKey].DeletedFieldsFormModel.filter((item) => item.controlId !== controlId) ?? [];

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          DeletedFieldsFormModel: [...filteredArray],
        },
      };
    }

    case ADD_ELEMENTS_TO_FORM_MODEL: {
      const { elements } = action.payload;

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formModel: { ...state[formKey].formModel, ...elements },
        },
      };
    }

    case REPLACE_ADDED_ELEMENTS_TO_FORM_MODEL: {
      const { addedElements } = action.payload;

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          AddedFieldsFormModel: [...addedElements],
        },
      };
    }

    case SET_FORM_IMPORT_MODE: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          isImportMode: action.payload,
        },
      };
    }

    case SET_IS_FORM_CHANGES_MODE: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          isFormChangesMode: action.payload.flag,
        },
      };
    }

    case SET_FORM_CHANGES_TABLE_ROWS: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          formChangesTableRows: action.payload.rows,
        },
      };
    }

    case SET_IS_FORM_CHANGES_TABLE_LOADING: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          isFormChangesTableLoading: action.payload.flag,
        },
      };
    }

    case SAVE_SIMILAR_RECORDS_DATA: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          similarRecords: { ...action.payload.similarRecordsData, isDataFetched: true },
        },
      };
    }

    case SET_SIMILAR_RECORDS_DATA_FETCHED: {
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          similarRecords: { isDataFetched: true },
        },
      };
    }

    case SET_SEARCH_RESULT: {
      const { searchText, searchId, searchIds } = action.payload;
      const searchIdIndex = searchIds.indexOf(searchId);

      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          searchResult: {
            searchText,
            searchId,
            searchIdIndex: searchIdIndex === -1 ? 0 : searchIdIndex,
            searchIdsCount: searchIds.length,
          },
        },
      };
    }

    default:
      return state;
  }
}

export default formManagerReducer;
